import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';
import { on, reducer } from 'ts-action';
import * as undoActions from '../../undo/actions/undo.actions';
import * as ecgListActions from '../actions/ecg-list.actions';
import { EcgItem } from '../types/ecg.type';

export interface EcgListState extends EntityState<EcgItem> {
  currentIndex: number;
  done: boolean;
}

declare module 'react-redux' {
  interface DefaultRootState {
    ecgList: EcgListState;
  }
}

const ecgListAdapter = createEntityAdapter<EcgItem>();

export const {
  selectAll,
  selectEntities,
  selectTotal,
} = ecgListAdapter.getSelectors();

export default reducer<EcgListState>(
  ecgListAdapter.getInitialState({ currentIndex: 0, done: false }),
  on(
    ecgListActions.incrementIndex,
    (state): EcgListState => {
      const currentIndex = state.currentIndex + 1;
      return {
        ...state,
        currentIndex,
      };
    },
  ),
  on(
    ecgListActions.reset,
    (_state): EcgListState =>
      ecgListAdapter.getInitialState({ currentIndex: 0, done: false }),
  ),
  on(ecgListActions.done, (state): EcgListState => ({ ...state, done: true })),
  on(
    ecgListActions.loaded,
    (state, { ecgItems }): EcgListState =>
      ecgListAdapter.upsertMany(state, ecgItems),
  ),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { ecgList } }): EcgListState => {
      if (!ecgList) {
        return state;
      }
      return { ...state, ...ecgList };
    },
  ),
);
